import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useGlobalControls } from '../context/GlobalControlsContext';
import { useQueryStrings } from '../context/QueryStringContext';
import LineupDetailsPage from './LineupDetailsPage';
import OfferDetailsPage from './OfferDetailsPage';
import ExploreDetailsPage from './ExploreDetailsPage';
import { useData } from '../context/DataContext';

type DetailsDeciderProps = DetailsDeciderPropsBase & RouteComponentProps;

interface DetailsDeciderPropsBase {}

function DetailsDecider(props: DetailsDeciderProps) {
  const { ...rest } = props;
  const { qs } = useQueryStrings();
  const { toggleOverflow } = useGlobalControls();
  const { dateLineup } = useData();
  const { todayLineup } = useData();

  useEffect(() => {
    toggleOverflow('details', !!qs.event || !!qs.venue || !!qs.offer);
    document.querySelector('.blur-container')?.scrollTo({ top: 0 });
  }, [qs]);

  const event =
    dateLineup.events.find(evt => evt.id === qs.event) ||
    dateLineup.events.find(evt => evt.templateId === qs.eventTemplateId);

  const venue = todayLineup.venues.find(venue => venue.templateId === qs.venue);

  const offer =
    todayLineup.offers.find(offer => offer.id === qs.offer) ||
    todayLineup.offers.find(offer => offer.templateId === qs.offerTemplateId);

  if (event) {
    return <LineupDetailsPage {...rest} event={event} />;
  }

  if (venue) {
    return <ExploreDetailsPage {...rest} venue={venue} />;
  }

  if (offer) {
    return <OfferDetailsPage {...rest} offer={offer} />;
  }

  return <></>;
}

export default DetailsDecider;
